export default function({
    actionTypes: {
        ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_MANAGER_SET,
        CAN_MODIFY_ANY_USER_SET,
    }
}) {
    return {
        initialState: {
            assignedUsers: [],
            assignedManagers: [],
            canModifyAnyManager: false,
            canModifyAnyUser: false,
        },

        handlers: {
            [ASSIGNED_USERS_SET]: (state, {payload: assignedUsers}) => ({...state, assignedUsers}),
            [CAN_MODIFY_ANY_USER_SET]: (state, {payload: canModifyAnyUser}) => ({...state, canModifyAnyUser}),
            [ASSIGNED_MANAGERS_SET]: (state, {payload: assignedManagers}) => ({...state, assignedManagers}),
            [CAN_MODIFY_ANY_MANAGER_SET]: (state, {payload: canModifyAnyManager}) => ({...state, canModifyAnyManager})
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/reducerGenerator.js